import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface AssignSelectorFilterValues {
  name: string;
}

export const AssignSelectorFilter = ({ children }: PropsWithChildren<any>) => {
  const filterItems: Item<AssignSelectorFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<AssignSelectorFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
    >
      {children}
    </FilterBar>
  );
};
